import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Links } from "../Links";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var GroupLinks = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('group-links')
  }, data.map(function (links) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('group-links__item'),
      key: links.title
    }, /*#__PURE__*/React.createElement(Links, {
      data: links.data,
      title: links.title
    }));
  }));
});